module.exports = __webpack_public_path__ + "static/media/wicket3.9176fc9d.png";